<div class="pharmacie-edit-container">
    <form *ngIf="pharmacieForm" [formGroup]="pharmacieForm" (ngSubmit)="onSubmit()">
        <div class="section section-edit">
            <div class="section-edit-title">
                <h3>Votre Pharmacie</h3>
            </div>
            <div class="section-edit-form">
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Votre code sogiphar : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="codeSogiphar" />
                    </div>
                </div>

                <div *ngIf="submitted && field.nomPharmacie.errors" class="invalid-feedback">
                    <div *ngIf="field.nomPharmacie.errors.required">Le nom de la pharmacie est requis</div>
                </div>
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Nom de votre pharmacie : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="nomPharmacie"
                            [ngClass]="{'is-invalid': submitted && field.nomPharmacie.errors }" />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Code postal de la pharmacie : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="codePostal" />
                    </div>
                </div>

                <div *ngIf="submitted && field.emailPharmacie.errors" class="invalid-feedback">
                    <div *ngIf="field.emailPharmacie.errors.required">L'adresse mail de la pharmacie est requise</div>
                    <div *ngIf="field.emailPharmacie.errors.pattern">L'adresse mail de la pharmacie est incorrecte</div>
                </div>
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Email de la pharmacie : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="email" formControlName="emailPharmacie"
                            [ngClass]="{'is-invalid': submitted && field.emailPharmacie.errors }" />
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-edit">
            <div class="section-edit-title">
                <h3>Pharmacien responsable</h3>
            </div>
            <div class="section-edit-form">
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Nom du pharmacien : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="nomTitulaire" />
                    </div>
                </div>

                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Prénom du pharmacien : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="prenomTitulaire" />
                    </div>
                </div>

                <div *ngIf="submitted && field.emailTitulaire.errors" class="invalid-feedback">
                    <div *ngIf="field.emailTitulaire.errors.required">L'adresse mail du pharmacien est requise</div>
                    <div *ngIf="field.emailTitulaire.errors.pattern">L'adresse mail du pharmacien est incorrecte</div>
                </div>
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Adresse email du pharmacien (<label class="text-danger">*</label>) : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="email" formControlName="emailTitulaire"
                            [ngClass]="{'is-invalid': submitted && field.emailTitulaire.errors }" />
                    </div>
                </div>

                <div *ngIf="submitted && field.telephoneTitulaire.errors" class="invalid-feedback">
                    <div *ngIf="field.telephoneTitulaire.errors.required">Le numéro de téléphone du pharmacien est requis</div>
                </div>
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Numéro pour alerte SMS (<label class="text-danger">*</label>) : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="telephoneTitulaire"
                            [ngClass]="{'is-invalid': submitted && field.telephoneTitulaire.errors }" />
                    </div>
                </div>

                <div *ngIf="submitted && field.telephonePharmacie.errors" class="invalid-feedback">
                    <div *ngIf="field.telephonePharmacie.errors.required">Le numéro de téléphone de la pharmacie est requis</div>
                </div>
                <div class="form-group row">
                    <div class="section-edit-form-label col-md-6">
                        <label>Second numéro pour alerte SMS (<label class="text-danger">**</label>) : </label>
                    </div>
                    <div class="section-edit-form-input col-md-6">
                        <input type="text" formControlName="telephonePharmacie"
                            [ngClass]="{'is-invalid': submitted && field.telephonePharmacie.errors }" />
                    </div>
                </div>
            </div>
        </div>
        <div class="section section-edit">
            <div class="section-edit-title">
                <h3>Gestion des notifications</h3>
            </div>
          <div class="form-group row">
            <div class="section-edit-form-label col-md-4">
              <label>A la pharmacie</label>
            </div>
            <div class="section-edit-form-input col-md-4">
              <label>mail: </label>
              <input class="edit-form-input-checkbox" type="checkbox" formControlName="notifMailPhie" />
            </div>
            <div class="section-edit-form-input col-md-4">
              <label>SMS (**): </label>
              <input class="edit-form-input-checkbox" type="checkbox" formControlName="notifSmsPhie" />
            </div>
          </div>
            <div class="form-group row">
                <div class="section-edit-form-label col-md-4">
                    <label>Au pharmacien</label>
                </div>
                <div class="section-edit-form-input col-md-4">
                    <label>mail: </label>
                    <input class="edit-form-input-checkbox" type="checkbox" formControlName="notifMailPhien" />
                </div>
                <div class="section-edit-form-input col-md-4">
                    <label>SMS (*): </label>
                    <input class="edit-form-input-checkbox" type="checkbox" formControlName="notifSms" />
                </div>
            </div>
        </div>

        <div class="section section-edit">
            <div class="section-edit-title">
                <h3>Autoriser l'envoi des ordonnances</h3>
            </div>
            <div class="section-edit-form-input col-md-12">
                <label>Activé: </label>
                <input class="edit-form-input-checkbox" type="checkbox" [(ngModel)]="hideMessage" formControlName="actif" />
                <p class="text-danger" *ngIf="!hideMessage">
                    Veuillez cocher la case pour autoriser l'envoi et la réception d'ordonnances
                </p>
            </div>
        </div>
    </form>
</div>
